import Modal from "./Modal"
import useCreateFamilyPost from "../../hooks/post/useCreateUpdatePost"
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import axiosRetry from 'axios-retry';
import { useTranslation } from "react-i18next";
import currencies from "../../components/currencies";
import { countryCodes } from "../../components/countryCodes";
import country from "../../components/country";

import FamilyPostDocProofs from "./PostDocProofs/FamilyPostDocProofs";
import MedicalPostDocProofs from "./PostDocProofs/MedicalPostDocProofs";
import MarriagePostDocProofs from "./PostDocProofs/MarriagePostDocProofs";

import FamilyPostVideoProofs from "./PostVideoProofs/FamilyPostVideoProofs";
import MedicalPostVideoProofs from "./PostVideoProofs/MedicalPostVideoProofs";
import MarriagePostVideoProofs from "./PostVideoProofs/MarriagePostVideoProofs";
import MadrasaPostVideoProofs from "./PostVideoProofs/MadrasaPostVideoProofs";
import MasjidPostVideoProofs from "./PostVideoProofs/MasjidPostVideoProofs";
import OrphanPostVideoProofs from "./PostVideoProofs/OrphanPostVideoProofs";
import WidowPostVideoProofs from "./PostVideoProofs/WidowPostVideoProofs";
import WidowPostDocProofs from "./PostDocProofs/WidowPostDocProofs";
import OrphanPostDocProofs from "./PostDocProofs/OrphanPostDocProofs";
import MadrasaPostDocProofs from "./PostDocProofs/MadrasaPostDocProofs";
import MasjidPostDocProofs from "./PostDocProofs/MasjidPostDocProofs";
import FileUploader from "../../components/FileUploader";



const CreateUpdatePostModal = () => {
  const { isOpen, isUpdate, postData, docData, close } = useCreateFamilyPost();
  const {t} = useTranslation('create-post')
  const translation = t('create-update-case')
  
  // States
  const [currentState, setCurrentStep] = useState('basic_guidlines');
  const [postDataErrorMessage, setPostDataErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [postSlug, setPostSlug] = useState('');
  const [postVideos, setPostVideo] = useState(null)

  

 
  // UI state
  const [selectSeeker, setSelectSeeker] = useState([])
  const [selectedSeeker, setSelectedSeeker] = useState('')

  const [oldRegistrationCertificate, setOldRegistrationCertificate] = useState(null);

  const [isCreateSeeker, setIsCreateSeeker] = useState(true)
  const [showBankDetailFields, setShowBankDetailFields] = useState(true)
  const [seekerDataId, setSeekerDataId] = useState(null)

  const [postType, setPostType] = useState("")
  const [seekerType, setSeekerType] = useState("")

  const navigate = useNavigate();
  axiosRetry(axios, { retries: 3 }); 

  const today = new Date().toISOString().split('T')[0];
  const nextYear = new Date();
  nextYear.setFullYear(nextYear.getFullYear() + 1);
  const maxDate = nextYear.toISOString().split('T')[0];


  const [formData, setFormData] = useState({
    need: '',
    need_type: "onetime",
    need_before: "",
    need_for: "",
    currency: "",
    description: '',
    cnic: '',
    needed_money: 0,
    post_type: ''
  });

  const [originalFormData, setOriginalFormData] = useState({
    need: '',
    need_type: "onetime",
    need_before:"",
    need_for: "",
    currency: "",
    cnic: '',
    description: '',
    needed_money: 0,
    post_type: ""
  });
  
  const [seekerData, setSeekerData] = useState({
    name: '',
    address: '',
    phone_number: '',
    country_code: countryCodes[0].code,
    cnic: "",
    country: country[0].name,
    type: ""
  });

  const [originalSeekerData, setOriginalSeekerData] = useState({
    name: '',
    address: '',
    phone_number: '',
    country_code: "",
    cnic: "",
    country: "",
    type: ""
  });


  const [bankFormData, setBankFormData] = useState({
    bank_name: '',
    account_number: '',
    account_holder: '',
    slug: '',
  });

  const [originalbankFormData, setOriginalBankFormData] = useState({
    bank_name: '',
    account_number: '',
    account_holder: '',
    slug: '',
  });


  useEffect(() => {
    if (currentState === "select_create_seeker") {
      const fetchSeekers = async () => {
        try {
          const config = {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
          };
          const { data, status } = await axios.get(
            `${process.env.REACT_APP_BACKEND_DOMAIN}/post/get-creator-seeker/`,
            config
          );

          if (status === 200) {
            setPostDataErrorMessage('')
            setSelectSeeker(data.data);
            if (!isUpdate && data.data.length > 0 ){
              setIsCreateSeeker(false)
            }
          }
        } catch (err) {
          setPostDataErrorMessage(err.message || 'Something went wrong');
        }
      };

      fetchSeekers();
    }
  }, [currentState, isUpdate]);


  const handlePostDataChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    setFormData((prevData) => ({
      ...prevData,
      [name]: val,
    }));
  };

  const handleBankDataChange = (e) => {
    setBankFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };


  const viewPost = async (e) => {
    close();
    navigate(`/detail/${postSlug}`)
  } 

  const SubmitPostData = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    
    // Clear previous errors
    setPostDataErrorMessage("");
  
    // Client-side validation
    const requiredFields = {
      need: translation.need,
      need_type: translation.need_type_lab, 
      need_for: translation.need_for_lab,
      need_before: translation.need_before,
      currency: translation.currency,
      needed_money: translation.money_need,
      description: translation.seeker_situation,
    };
  
    // Check for missing required fields
    const missingField = Object.entries(requiredFields).find(
      ([field]) => !formData[field]?.toString().trim()
    );
  
    if (missingField) {
      const label = missingField[1];
      setPostDataErrorMessage(`${label}: ${translation.required_field}`);
      setIsLoading(false);
      return;
    }
    
    if (selectedSeeker){
      formData['cnic'] = selectedSeeker
    } else {
      formData['cnic'] = seekerData['cnic']
    }

    const jsonData = JSON.stringify(formData);

    // Create post
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      }
    };

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_DOMAIN +'/post/create-post/', jsonData, config);
      setIsLoading(false)

      if (response.status === 201) {
        setPostSlug(response.data.slug);
        setCurrentStep("create_bank_details");
        setPostDataErrorMessage("")
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData?.error?.non_field_errors && Array.isArray(errorData?.error?.non_field_errors)){
          setPostDataErrorMessage(errorData.error.non_field_errors[0]); 
        }
        else if (errorData?.detail) {
          setPostDataErrorMessage(errorData?.detail); 
        } 
        else if (errorData?.error && Array.isArray(errorData?.error?.error)) {
          setPostDataErrorMessage(errorData.error.error[0]); 
        } 
        else if (errorData.error?.need_type){
          setPostDataErrorMessage(`${translation.need_type }: ` + errorData.error.need_type[0]); 
        } 
        else if (errorData.error?.need_before){
          setPostDataErrorMessage(`${translation.need_before }: ` + errorData.error.need_before[0]); 
        } 
        else if (errorData.error?.need_before){
          setPostDataErrorMessage(`${translation.need_before || 'need type'}: ` + errorData.error.need_before[0]); 
        } 
        else if (errorData.error?.need){
          setPostDataErrorMessage(`${translation.need }: ` + errorData.error.need[0]); 
        } 
        else if (errorData.error?.need_for){
          setPostDataErrorMessage(`${translation.need_for}: ` + errorData.error.need_for[0]); 
        } 
        else if (errorData.error?.currency){
          setPostDataErrorMessage(`${translation.currency}: ` + errorData.error.currency[0]); 
        } 
        else if (errorData.error?.needed_money){
          setPostDataErrorMessage(`${translation.money_need}: ` + errorData.error.needed_money[0]); 
        } 
        else if (errorData.error?.post_type){
          setPostDataErrorMessage(`${translation.post_type}: `+ errorData.error.post_type[0]); 
        } 
        else if (errorData.error?.description){
          setPostDataErrorMessage(`${translation.seeker_situation}: ` + errorData.error.description[0]); 
        } 
        else if (typeof errorData.error === "string") {
          setPostDataErrorMessage(errorData.error);
        } else {
          setPostDataErrorMessage(`${translation.unexpected_error_message}`);
        }
      } else {
        setPostDataErrorMessage(`${translation.unexpected_error_message}`);
      };
    };


  };

  const SubmitPostBankData = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    if (!showBankDetailFields) {
      setCurrentStep("attach_video_proofs");
      setPostDataErrorMessage("");
      setIsLoading(false);
      return; 
    }

    setPostDataErrorMessage('');

    // Client-side validation
    const requiredFields = {
      bank_name: translation.bank_details.bank_name,
      account_holder: translation.bank_details.account_holder_name,
      account_number: translation.bank_details.account_number
    };

    const missingField = Object.entries(requiredFields).find(
      ([field]) => !bankFormData[field]?.toString().trim()
    );

    if (missingField) {
      const label = missingField[1];
      setPostDataErrorMessage(`${label}: ${translation.required_field}`);
      setIsLoading(false);
      return;
    }
    bankFormData['slug'] = postSlug
    const jsonData = JSON.stringify(bankFormData);
  
    // Create post
    const config = {
      headers: {
        'Content-Type': 'application/json', // Use JSON content type
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      }
    };

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_DOMAIN +'/post/create-post-bank-details/', jsonData, config);
      setIsLoading(false)

      if (response.status === 201) {
        setCurrentStep("attach_video_proofs");
        setPostDataErrorMessage("")
      }
    } catch (error) {

      setIsLoading(false);
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData?.error && Array.isArray(errorData.error.error)) {
          setPostDataErrorMessage(errorData.error.error[0]); 
        } 
        else if (errorData?.error.account_number){
          setPostDataErrorMessage(`${translation.bank_details.account_number}: `+ errorData.error.account_number[0]); 
        } 
        else if (errorData?.error.account_holder){
          setPostDataErrorMessage(`${translation.bank_details.account_holder_name}: ` + errorData.error.account_holder[0]); 
        } 
        else if (errorData?.error.bank_name){
          setPostDataErrorMessage(`${translation.bank_details.bank_name}: ` + errorData.error.bank_name[0]); 
        } 
        else if (typeof errorData?.error === "string") {
          setPostDataErrorMessage(errorData.error);
        } else {
          setPostDataErrorMessage(`${translation.unexpected_error_message}`);
        }
      }else {
        setPostDataErrorMessage(`${translation.unexpected_error_message}`);
      };
    };
  };

  const SubmitPostSeekerData = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    // Clear previous errors
    setPostDataErrorMessage("");
  
    // Client-side validation
    const seekerRequiredFields = {
      name: translation.seeker_name,
      address: translation.address,
      phone_number: translation.phone_number,
      cnic: translation.seeker_cnic,
      type: translation.asking_for,
      country: translation.country_lab
    };
  
    // Check for missing required fields
    const missingField = Object.entries(seekerRequiredFields).find(
      ([field]) => !seekerData[field]?.toString().trim()
    );
  
    if (missingField) {
      const label = missingField[1];
      setPostDataErrorMessage(`${label}: ${translation.required_field}`);
      setIsLoading(false);
      return;
    }
  

    const jsonData = JSON.stringify(seekerData);
  
    // Create post
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      }
    };

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_DOMAIN +'/post/create-post-seeker/', jsonData, config);
      setIsLoading(false)

      if (response.status === 201) {
        // getPostAllData()
        setSeekerDataId(response.data.data.id)
        if (["ngo", "madrasa", "masjid"].includes(seekerData.type)){
          setCurrentStep("upload_seeker_details");
        } else {
          setCurrentStep("create_post_details");
        }
        setSelectedSeeker(jsonData['cnic'])
        setPostDataErrorMessage("")
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData?.error?.non_field_errors && Array.isArray(errorData?.error?.non_field_errors)){
          setPostDataErrorMessage(errorData.error.non_field_errors[0]); 
        }
        else if (errorData?.detail) {
          setPostDataErrorMessage(errorData?.detail); 
        } 
        else if (errorData && Array.isArray(errorData?.error)) {
          setPostDataErrorMessage(errorData.error[0]); 
        } 
        else if (errorData?.name){
          setPostDataErrorMessage(`${translation.seeker_name}: ` + errorData.name[0]); 
        } 
        else if (errorData?.address){
          setPostDataErrorMessage(`${translation.address}: ` + errorData.address[0]); 
        } 
        else if (errorData?.country){
          setPostDataErrorMessage(`${translation.country}: ` + errorData.country[0]); 
        } 
        else if (errorData?.phone_number){
          setPostDataErrorMessage(`${translation.phone_number}: ` + errorData.phone_number[0]); 
        } 
        else if (errorData?.cnic){
          setPostDataErrorMessage(`${translation.seeker_cnic}: ` + errorData.cnic[0]); 
        } 
        else if (errorData?.type){
          setPostDataErrorMessage(`${translation.asking_for}: ` + errorData.type[0]); 
        } 
        
        else if (typeof errorData === "string") {
          setPostDataErrorMessage(errorData);
        } else {
          setPostDataErrorMessage(`${translation.unexpected_error_message}`);
        }
      } else {
        setPostDataErrorMessage(`${translation.unexpected_error_message}`);
      };
    };
  };

  const fillAllData = () =>{
      // call apis to fill the post-form-data
    if (isUpdate){
      setPostSlug(postData.slug)
      setShowBankDetailFields(true)
      
      const formatDateToInput = (dateString) => {
        const parsedDate = new Date(dateString);
        const year = parsedDate.getFullYear();
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
        const day = String(parsedDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const fixedPostData = {
        ...postData,
        need_before: formatDateToInput(postData.need_before)
      };
      
      setPostType(fixedPostData.post_type)
      setFormData(fixedPostData);
      setOriginalFormData(fixedPostData)

      if (postData?.bank_detail){
        setBankFormData(postData.bank_detail);
        setOriginalBankFormData(postData.bank_detail)
      } 

      if (postData?.post_videos){
        setPostVideo(postData.post_videos)
      }

      // if (docData){
      //   setOldCnicFile(docData?.documents?.cnic_front)
      //   setOldElectricBill(docData?.documents?.electric_bill)
      //   setUploadedCnicFile(true)
      //   setUploadedEetectricFile(true)
      // }

      if (postData?.seeker){
        setIsCreateSeeker(true)
        setSeekerData(postData.seeker)
        setFormData((prevData) => ({
          ...prevData,
          cnic: postData.seeker.cnic,
        }))

        setOriginalFormData((prevData) => ({
          ...prevData,
          cnic: postData.seeker.cnic,
        }))
        
        const docKey = `${postData.seeker.type}_registration_certificate`;
        const certificate = postData?.seeker?.documents?.[docKey];
        if (certificate) {
          setOldRegistrationCertificate(certificate);
        }

        setSeekerDataId(postData.seeker.id)
        setOriginalSeekerData(postData.seeker)
      }
    }
  }

  const UpdatePostData = async (e) => {
    e.preventDefault();
    setIsLoading(true)


    // Always include the CNIC
    if (selectedSeeker){
      formData['cnic'] = selectedSeeker
    } else {
      formData['cnic'] = seekerData['cnic']
    }
    // Compute only the fields that actually changed
    const updatedFields = Object.keys(formData).reduce((acc, key) => {
      if (formData[key] !== originalFormData[key]) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});                                                                      
    
    // EARLY RETURN: if nothing changed, go straight to step 2
    if (Object.keys(updatedFields).length === 0) {
      setIsLoading(false);
      setCurrentStep("create_bank_details");
      return;
    }



    // Create post
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      }
    };
 
    try {
      const response = await axios.put(`${process.env.REACT_APP_BACKEND_DOMAIN}/post/update-post/${postSlug}/`, JSON.stringify(updatedFields), config);

      if (response.status === 200) {
        setPostSlug(response.data.slug);
        setCurrentStep("create_bank_details");
        setPostDataErrorMessage("")
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData?.error?.non_field_errors && Array.isArray(errorData?.error?.non_field_errors)){
          setPostDataErrorMessage(errorData.error.non_field_errors[0]); 
        }
        else if (errorData?.detail) {
          setPostDataErrorMessage(errorData?.detail); 
        } 
        else if (errorData?.error && Array.isArray(errorData?.error?.error)) {
          setPostDataErrorMessage(errorData.error.error[0]); 
        } 
        else if (errorData.error?.need_type){
          setPostDataErrorMessage(`${translation.need_type || 'need type'}: ` + errorData.error.need_type[0]); 
        } 
        else if (errorData.error?.need_before){
          setPostDataErrorMessage(`${translation.need_before || 'need before'}: ` + errorData.error.need_before[0]); 
        } 
        else if (errorData.error?.need){
          setPostDataErrorMessage(`${translation.need || 'need'}: ` + errorData.error.need[0]); 
        } 
        else if (errorData.error?.need_for){
          setPostDataErrorMessage(`${translation.need_for || "need_for"}: ` + errorData.error.need_for[0]); 
        } 
        else if (errorData.error?.currency){
          setPostDataErrorMessage(`${translation.currency || 'currency'}: ` + errorData.error.currency[0]); 
        } 
        else if (errorData.error?.needed_money){
          setPostDataErrorMessage(`${translation.money_need}: ` + errorData.error.needed_money[0]); 
        } 
        else if (errorData.error?.post_type){
          setPostDataErrorMessage(`${translation.post_type}: `+ errorData.error.post_type[0]); 
        } 
        else if (errorData.error?.description){
          setPostDataErrorMessage(`${translation.seeker_situation}: ` + errorData.error.description[0]); 
        } 
        else if (typeof errorData.error === "string") {
          setPostDataErrorMessage(errorData.error);
        } else {
          setPostDataErrorMessage(`${translation.unexpected_error_message}`);
        }
      } else {
        setPostDataErrorMessage(`${translation.unexpected_error_message}`);
      };
    };


  };

  const UpdatePostSeekerData = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    
    // Clear previous errors
    setPostDataErrorMessage("");

    // Client-side validation
    const seekerRequiredFields = {
        name: translation.seeker_name,
        address: translation.address,
        phone_number: translation.phone_number,
        cnic: translation.seeker_cnic,
        type: translation.asking_for,
        country: 'country'
    };

    // Check for missing required fields using UPDATED data
    const missingField = Object.entries(seekerRequiredFields).find(
        ([field]) => !seekerData[field]?.toString().trim()
    );

    if (missingField) {
        const label = missingField[1];
        setPostDataErrorMessage(`${label}: ${translation.required_field}`);
        setIsLoading(false);
        return;
    }

    // Calculate changed fields
    const changedData = {};
    Object.keys(seekerData).forEach(key => {
        if (seekerData[key] !== originalSeekerData[key]) {
            changedData[key] = seekerData[key];
        }
    });

    // If no changes, skip API call
    if (Object.keys(changedData).length === 0) {
        if (["ngo", "madrasa", "masjid"].includes(seekerData.type)){
          setCurrentStep("upload_seeker_details");
        } else {
          setCurrentStep("create_post_details");
        }
        
        setPostDataErrorMessage("");
        setIsLoading(false);
        return;
    }

    changedData['id'] = seekerDataId

    const jsonData = JSON.stringify(changedData);

    // Create post
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
    };

    try {
        const response = await axios.put(
            process.env.REACT_APP_BACKEND_DOMAIN + '/post/update-post-seeker/',
            jsonData,
            config
        );
        
        setIsLoading(false);

        if (response.status === 200) {
            // Update original data with new changes
            setOriginalSeekerData(response.data.data);
            setSeekerData(response.data.data)
            if (["ngo", "madrasa", "masjid"].includes(seekerData.type)){
              setCurrentStep("upload_seeker_details");
            } else {
              setCurrentStep("create_post_details");
            }
            
            setPostDataErrorMessage("");
        }
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData?.error?.non_field_errors && Array.isArray(errorData?.error?.non_field_errors)){
          setPostDataErrorMessage(errorData.error.non_field_errors[0]); 
        }
        else if (errorData?.detail) {
          setPostDataErrorMessage(errorData?.detail); 
        } 
        else if (errorData?.error && Array.isArray(errorData?.error?.error)) {
          setPostDataErrorMessage(errorData.error.error[0]); 
        } 
        else if (errorData.error?.name){
          setPostDataErrorMessage(`${translation.seeker_name}: ` + errorData.error.name[0]); 
        } 
        else if (errorData.error?.address){
          setPostDataErrorMessage(`${translation.address}: ` + errorData.error.address[0]); 
        } 
        else if (errorData.error?.country){
          setPostDataErrorMessage(`${translation.country}: ` + errorData.error.country[0]); 
        } 
        else if (errorData.error?.phone_number){
          setPostDataErrorMessage(`${translation.phone_number}: ` + errorData.error.phone_number[0]); 
        } 
        else if (errorData.error?.cnic){
          setPostDataErrorMessage(`${translation.seeker_cnic}: ` + errorData.error.cnic[0]); 
        } 
        else if (errorData.error?.type){
          setPostDataErrorMessage(`${translation.asking_for}: ` + errorData.error.type[0]); 
        } 
        
        else if (typeof errorData.error === "string") {
          setPostDataErrorMessage(errorData.error);
        } else {
          setPostDataErrorMessage(`${translation.unexpected_error_message}`);
        }
      } else {
        setPostDataErrorMessage(`${translation.unexpected_error_message}`);
      };
    };
  };

  const UpdatePostBankData = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    if (!showBankDetailFields) {
      setCurrentStep("attach_video_proofs");
      setPostDataErrorMessage("");
      setIsLoading(false);
      return; 
    }

    setPostDataErrorMessage('');

    // Client-side validation
    const requiredFields = {
      bank_name: translation.bank_details.bank_name,
      account_holder: translation.bank_details.account_holder_name,
      account_number: translation.bank_details.account_number
    };

    const missingField = Object.entries(requiredFields).find(
      ([field]) => !bankFormData[field]?.toString().trim()
    );

    if (missingField) {
      const label = missingField[1];
      setPostDataErrorMessage(`${label}: ${translation.required_field}`);
      setIsLoading(false);
      return;
    }

    // Calculate changed fields
    const updatedData = {};
    Object.keys(bankFormData).forEach((key) => {
      if (bankFormData[key] !== originalbankFormData[key]) {
        updatedData[key] = bankFormData[key];
      }
    });

    // If no changes, skip API call
    if (Object.keys(updatedData).length === 0) {
      setCurrentStep("attach_video_proofs");
      setPostDataErrorMessage("");
      setIsLoading(false);
      return;
    }

    updatedData['slug'] = postSlug
    const jsonData = JSON.stringify(updatedData);
    // Create post
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      }
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_DOMAIN + '/post/update-post-bank-details/',
        jsonData,
        config
      );
      
      setIsLoading(false)

      if (response.status === 200) {
        // Update original data with new changes
        setOriginalBankFormData(bankFormData);
        setCurrentStep("attach_video_proofs");
        setPostDataErrorMessage("")
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData?.error && Array.isArray(errorData.error.error)) {
          setPostDataErrorMessage(errorData.error.error[0]); 
        } 
        else if (errorData?.error.account_number){
          setPostDataErrorMessage(`${translation.bank_details.account_number}: `+ errorData.error.account_number[0]); 
        } 
        else if (errorData?.error.account_holder){
          setPostDataErrorMessage(`${translation.bank_details.account_holder_name}: ` + errorData.error.account_holder[0]); 
        } 
        else if (errorData?.error.bank_name){
          setPostDataErrorMessage(`${translation.bank_details.bank_name}: ` + errorData.error.bank_name[0]); 
        } 
        else if (typeof errorData?.error === "string") {
          setPostDataErrorMessage(errorData.error);
        } else {
          setPostDataErrorMessage(`${translation.unexpected_error_message}`);
        }
      } else {
        setPostDataErrorMessage(`${translation.unexpected_error_message}`);
      }
    };
  };


  const content = (
    <>

      {currentState === "basic_guidlines" ? (
        <>
          <h2 className="mb-8 text-2xl font-bold text-gray-800 dark:text-white/90 mx-2">
            {translation.create_post_info}
          </h2>

          <div className="grid gap-3">
            <div className="group relative overflow-hidden rounded-xl bg-teal-50 p-6 shadow-lg transition-all hover:shadow-xl dark:bg-teal-900/30">
              <div className="absolute -right-6 -top-6 text-9xl text-teal-100 opacity-50 transition-opacity group-hover:opacity-70 dark:text-teal-800">
                <i className="fas fa-user-edit"></i>
              </div>
              <div className="relative">
                <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                  {translation.info_creator_points.map((mess, index) => (
                    <li key={index} className="flex items-start ">
                      <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-teal-600 mx-2"></span>
                      <span className="ltr:text-left rtl:text-right">{mess}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>

          <div className="flex space-x-3">
            <button
              onClick={() => {
                if (isUpdate) {
                  setCurrentStep("post_guidlines");
                  fillAllData();
                } else {
                  setCurrentStep("select_post_type");
                }
              }}   
              className="w-full mt-2 rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
            >
              {translation.start_creating_post}
            </button>

          </div>

        </> 
        ): currentState === "select_post_type" ? ( 
          <>

            <div className="flex flex-col mb-10">
              <h2 className="mb-2 text-2xl dark:text-white">{translation.creating_post_for}</h2>            
              <select
                id="post_type"
                name="post_type"
                value={postType}
                onChange={(e) => {
                  const selectedType = e.target.value;
                  setPostType(selectedType);
                  setFormData((prev) => ({
                    ...prev, 
                    post_type: selectedType
                  }));
                }}
                className="az-input-btn"
                required
              >
                <option value="">{translation.select_case}</option>
                <option value="family case">{translation.family} {translation.case} </option>
                <option value="marriage case">{translation.marriage} {translation.case}</option>
                <option value="medical case">{translation.medical} {translation.case}</option>

                <option value="madrasa case">{translation.madrasa} {translation.case}</option>
                <option value="masjid case">{translation.masjid} {translation.case}</option>
                <option value="orphan case">{translation.orphan} {translation.case}</option>
                <option value="widow case">{translation.widow} {translation.case}</option>

              </select>
            </div>

            <div className="flex space-x-3">
              <button
                onClick={() => {
                  setCurrentStep('basic_guidlines');
                  setPostType('');
                  }
                }
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
              >
                {translation.back}
              </button>

              <button
                onClick={() => setCurrentStep("post_guidlines")}
                disabled={!postType}
                className={`w-full rounded-md text-white font-extrabold px-4 py-2 
                  ${!postType 
                    ? "bg-gray-400 cursor-not-allowed" 
                    : "bg-blue-500 hover:bg-blue-600 cursor-pointer"}
                `}
              >
                {translation.next}
              </button>

            </div>
          </>
        ): currentState === "post_guidlines" ? (
          <>
            <div className="grid gap-3">

              <div className="group relative overflow-hidden rounded-xl bg-yellow-50 p-6 shadow-lg transition-all hover:shadow-xl dark:bg-yellow-900/30">
                
                <div className="relative">
                  <div className="mb-4 flex items-center gap-3">
                    <h3 className="text-xl font-semibold text-gray-800 dark:text-white/90">
                      {translation.info_required_message}
                    </h3>
                  </div>
                  {postType === 'orphan case' ? (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_orphan_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>

                  ): postType === 'marriage case' ? (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_marriage_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>
                  ): postType === 'widow case' ? (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_widow_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>
                  ): postType === 'medical case' ? (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_medical_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>
                  ): postType === 'masjid case' ? (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_masjid_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>
                  ):postType === 'madrasa case' ? (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_madrasa_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>
                  ):  (
                    <ol className="space-y-3 pl-1 text-gray-700 dark:text-white/80">
                      {translation.guidlines_for_family_case.map((mess, index) => (
                        <li key={index} className="flex items-start">
                          <span className="mr-3 mt-1 inline-block h-2 w-2 shrink-0 rounded-full bg-yellow-600 mx-2"></span>
                          <span className="ltr:text-left rtl:text-right">{mess}</span>
                        </li>
                      ))}
                    </ol>
                  )}
                    

                </div>
              </div>
            </div>

            <div className="flex space-x-3 mt-2">
              <button
                onClick={() => {
                  setCurrentStep('select_post_type');
                  }
                }
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
              >
                {translation.back}
              </button>

              <button
                onClick={() => setCurrentStep("select_create_seeker")}
                disabled={!postType}
                className={`w-full rounded-md text-white font-extrabold px-4 py-2 
                  ${!postType 
                    ? "bg-gray-400 cursor-not-allowed" 
                    : "bg-blue-500 hover:bg-blue-600 cursor-pointer"}
                `}
              >
                {translation.next}
              </button>

            </div>


          </>
        ): currentState === "select_create_seeker" ? (
            <>
              {isCreateSeeker ? (
                // CREATE SEEKER FORM
                <>
                  <h2 className="mb-6 text-2xl dark:text-white">{translation.heading1}</h2>            
                  <div className="pt-2 pb-5 space-y-5">
                    <div className="flex flex-col">
                      <label htmlFor="seeker" className="block font-semibold mb-2 dark:text-white">{translation.seeker_name}</label>
                      <input
                        type="text"
                        id="seeker"
                        name="seeker"
                        placeholder={translation.seeker_name_ph}
                        value={seekerData.name}
                        onChange={(e) => {
                          setSeekerData((prevData) => ({
                            ...prevData,
                            name: e.target.value,
                          }));
                          setSeekerType(e.target.value)
                        }}
                        className="az-input-btn"
                        required
                      />
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="seeker_type" className="block font-semibold mb-2 dark:text-white">{translation.seeker_type}</label>
                      <select
                        id="seeker_type"
                        name="seeker_type"
                        value={seekerData.type}
                        onChange={(e) => {
                          setSeekerData((prevData) => ({
                            ...prevData,
                            type: e.target.value,
                          }));
                        }}
                        className="az-input-btn"
                        required
                      >
                        <option value="">{translation.select_anyone}</option>
                        <option value="family">{translation.family}</option>
                        <option value="widow">{translation.widow}</option>
                        <option value="bride">{translation.bride}</option>
                        <option value="patient">{translation.patient}</option>
                        <option value="orphen">{translation.orphan}</option>
                        <option value="madrasa">{translation.madrasa}</option>
                        <option value="masjid">{translation.masjid}</option>
                        <option value="ngo">{translation.ngo}</option>
                      </select>
                    </div>
                    
                    
                    <div className="flex flex-col">
                      <label htmlFor="country" className="block font-semibold mb-2 dark:text-white">{translation.select_country}</label>
                      <select 
                          value={seekerData.country}
                          onChange={(e) => {
                            setSeekerData((prevData) => ({
                              ...prevData,
                              country: e.target.value,
                            }))
                          }}
                          className="az-input-btn w-1/3"
                        >
                          {country.map((country) => (
                            <option key={country.name} value={country.name}>
                              {country.flag} {country.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    
                    <div className="flex flex-col">
                      <label htmlFor="address" className="block font-semibold mb-2 dark:text-white">{translation.address}</label>
                      <textarea
                        type="text"
                        id="address"
                        name="address"
                        placeholder={translation.address_ph}
                        value={seekerData.address}
                        onChange={(e) => {
                          setSeekerData((prevData) => ({
                            ...prevData,
                            address: e.target.value,
                          }))
                        }}
                        className="az-input-btn"
                        required
                      />
                    </div>
                    
                    <div className="flex flex-col">
                      <label htmlFor="phone" className="block font-semibold mb-2 dark:text-white">
                        {translation.phone_number}
                      </label>
                      <div className="flex gap-2">
                        {/* Country Code Dropdown */}
                        <select 
                          value={seekerData.country_code}
                          onChange={(e) => {
                            setSeekerData((prevData) => ({
                              ...prevData,
                              country_code: e.target.value,
                            }))
                          }}
                          className="az-input-btn w-1/3"
                        >
                          {countryCodes.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.flag} {country.code}
                            </option>
                          ))}
                        </select>

                        {/* Phone Number Input */}
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder={translation.phone_number_ph}
                          value={seekerData.phone_number}
                          onKeyDown={(e) => {
                            if (!/[0-9]/.test(e.key) && 
                                !["Backspace", "Delete", "Tab", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          min="0"
                          step="1"
                          maxLength={11}
                          inputMode="numeric"
                          onChange={(e) => {
                            setSeekerData((prevData) => ({
                              ...prevData,
                              phone_number: e.target.value,
                            }))
                          }}
                          className="az-input-btn w-2/3"
                          required
                        />
                      </div>
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="seeker_cnic" className="block font-semibold mb-2 dark:text-white">{translation.seeker_cnic}</label>
                      <input
                        type="tel"
                        id="seeker_cnic"
                        name="seeker_cnic"
                        placeholder={translation.seeker_cnic_ph}
                        value={seekerData.cnic}
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && 
                              !["Backspace", "Delete", "Tab", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        min="0"
                        step="1"
                        maxLength={15}
                        onChange={(e) => {
                          const value = e.target.value;
                          setSeekerData((prevData) => ({
                            ...prevData,
                            cnic: value,
                          }));
                        }}
                        className="az-input-btn"
                        required
                      />
                    </div>

                  </div>
                  
                  {/* Buttons for Create Seeker form */}
                  <div className="flex space-x-3">
                    {isLoading ? (
                      <div className="flex items-center loading-icon">
                        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900 dark:border-stone-100" />
                      </div>
                    ) : (
                      <>
                        <button
                          onClick={() => setCurrentStep("post_guidlines")}
                          className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
                        >
                          {translation.back}
                        </button>

                        {selectSeeker.length > 0 && (
                          <button
                            onClick={() => setIsCreateSeeker(false)}
                            className="w-full rounded-md bg-gray-500 text-white font-extrabold px-4 py-2 hover:bg-gray-600"
                          >
                            {translation.select_existing}
                          </button>
                        )}

                        <button
                          onClick={isUpdate ? UpdatePostSeekerData : SubmitPostSeekerData}
                          className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
                        >
                          {translation.next}
                        </button>
                      </>
                    )}
                  </div>

                </>
              ) : (
                // SELECT EXISTING SEEKER
                <>
                  <h2 className="mb-6 text-2xl dark:text-white">{translation.select_seeker}</h2>            
                  <div className="pt-2 pb-5 space-y-5">
                    {selectSeeker.length > 0 && (
                      <div className="flex flex-col">
                        <label
                          htmlFor="select_seeker"
                          className="block font-semibold mb-2 dark:text-white"
                        >
                          {translation.select_seeker}
                        </label>
                        <select
                          id="select_seeker"
                          name="select_seeker"
                          value={selectedSeeker}
                          onChange={(e) => 
                            { 
                            setSelectedSeeker(e.target.value);
                            const selected = selectSeeker.find(seeker => seeker.cnic === e.target.value);
                            setSeekerType(selected ? selected.name : '');
                            }}
                          className="az-input-btn"
                          required
                        >
                          <option value="">{translation.select_seeker}</option>
                          {selectSeeker.map((seeker) => (
                            <option key={seeker.cnic} value={seeker.cnic}>
                              {`${seeker.type} — ${seeker.name}`}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                  
                  {/* Buttons for Select Seeker form */}
                  <div className="flex space-x-3">
                    <button
                      onClick={() => setCurrentStep('post_guidlines')}
                      className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
                    >
                      {translation.back}
                    </button>
                    
                    <button
                      onClick={() => setIsCreateSeeker(true)}
                      className="w-full rounded-md bg-gray-500 text-white font-extrabold px-4 py-2 hover:bg-gray-600"
                    >
                      {translation.create_new}

                    </button>
                    
                    <button
                      onClick={() => setCurrentStep("create_post_details")}
                      className={`w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 ${!selectedSeeker ? 'opacity-50 cursor-not-allowed' : ''}`}
                      disabled={!selectedSeeker}
                    >
                      {translation.next}
                    </button>
                  </div>
                </>
              )}
              
              {/* Error message display - shared between both views */}
              {postDataErrorMessage && (
                <div className="az-error-message">
                  {postDataErrorMessage}
                </div>
              )}
            </>

            
        ): currentState === "upload_seeker_details" ? (
          <>
            {["ngo", "madrasa", "masjid"].includes(seekerData.type) && (
              <div className="flex flex-col space-y-1 my-4">
                <label htmlFor="registration_certificate" className="block font-semibold mb-2 dark:text-white">
                  {seekerData.type} {translation.other.registration_certificate}
                </label>
      
                <FileUploader
                  fileNameInDB={`${seekerData.type}_registration_certificate`}
                  key={`${seekerData.type}_registration_certificate`}
                  allowedTypes={['jpeg', 'pdf', 'jpg', 'png', 'bmp', 'webp', 'heic', 'heif']}
                  onSuccess={(filePath)=>{
                    setOldRegistrationCertificate(filePath)
                  }}
                  generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
                  updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-seeker-docs/`}
                  additionalFormData={{'id': seekerDataId}}
                  maxSizeMB={100}
                  awsUploadDestination={'seeker/username/docs'}
                  description={translation.other.reg_description}
                  showPreview={oldRegistrationCertificate ? `${process.env.REACT_APP_CDN_URL}/${oldRegistrationCertificate}` : null} 

                />
              </div>
            )}

            {/* Buttons for Create Seeker form */}
            <div className="flex space-x-5">
              {isLoading ? (
                <div className="flex items-center loading-icon">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900 dark:border-stone-100" />
                </div>
              ) : (
                <>
                  {isUpdate && (
                    <button
                      onClick={() => setCurrentStep("select_create_seeker")}
                      className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
                    >
                      {translation.back}
                    </button>
                  )}
                  <button 
                    type="button" 
                    onClick={()=>{setCurrentStep('create_post_details')}}
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {translation.next}
                  </button>
                </>
              )}
            </div>
            
          </>
        ): currentState === "create_post_details" ?  (
          <>
            <h2 className="mb-6 text-2xl dark:text-white">{seekerType} {translation.heading2}</h2>            
              <div className="pt-2 pb-5 space-y-5 ">

                <div className="flex flex-col">
                  <label htmlFor="need" className="block font-semibold mb-2 dark:text-white">{translation.need}</label>
                  <select
                    id="need"
                    name="need"
                    value={formData.need}
                    onChange={handlePostDataChange}
                    className="az-input-btn"
                    required
                  >
                    <option value="">{translation.need_details.select_need}</option>
                    <option value="zakat">{translation.need_details.zakat}</option>
                    <option value="donation">{translation.need_details.donation}</option>
                    <option value="help">{translation.need_details.help}</option>
                    <option value="anything">{translation.need_details.anything}</option>
                  </select>
                </div>

                {/* <div className="flex flex-col">
                  <label htmlFor="need_type" className="block font-semibold mb-2 dark:text-white">{translation.need_type}</label>
                  <select
                    id="need_type"
                    name="need_type"
                    value={formData.need_type}
                    onChange={handlePostDataChange}
                    className="az-input-btn"
                    required
                  >
                    <option value="">{translation.select_anyone}</option>
                     <option value="monthly">{translation.monthly}</option>
                      <option value="yearly">{translation.yearly}</option> 
                    <option value="onetime">{translation.onetime}</option>
                  </select>
                </div> */}

                <div className="flex flex-col">
                    <label htmlFor="needed_money" className="block font-semibold mb-2 dark:text-white">
                      {translation.money_need}
                    </label>
                   
                    
                    <div className="flex gap-2">
                      <select
                        id="currency"
                        name="currency"
                        value={formData.currency}
                        onChange={handlePostDataChange}
                        className="az-input-btn"
                        required
                      >
                        <option value="">{translation.select_curreny}</option>
                        {currencies.map((currency) => (
                          <option key={currency.value} value={currency.value}>
                            {currency.label}
                          </option>
                        ))}
                      </select>
                      
                      <input
                        type="number"
                          id="needed_money"
                          name="needed_money"
                          value={formData.needed_money}
                          placeholder={translation.money_need_ph}
                          onChange={handlePostDataChange}
                          onKeyDown={(e) => {
                            if (!/[0-9]/.test(e.key) && 
                                !["Backspace", "Delete", "Tab", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          min="0"
                          step="1"
                          inputMode="numeric"
                          className="az-input-btn"
                          required
                      />
                  </div>
                </div>

                <div className="flex flex-col">
                  <label htmlFor="need_before" className="block font-semibold mb-2 dark:text-white">{translation.need_before}</label>
                  <input
                    id="need_before"
                    name="need_before"
                    value={formData.need_before}
                    onChange={handlePostDataChange}
                    className="az-input-btn"
                    required
                    type="date"
                    min={today}
                    max={maxDate}
                    onClick={(e) => {e.target.showPicker && e.target.showPicker();}}
                  />
                </div>

                <div className="flex flex-col">
                    <label htmlFor="need_for" className="block font-semibold mb-2 dark:text-white">{translation.need_for}</label>
                    <textarea
                      id="need_for"
                      name="need_for"
                      value={formData.need_for}
                      placeholder={translation.need_for_ph}
                      onChange={handlePostDataChange}
                      className="az-input-btn"
                      required
                    />
                </div>

                <div className="flex flex-col">
                    <label htmlFor="description" className="block font-semibold mb-2 dark:text-white">{translation.seeker_situation}</label>
                    <textarea
                      id="description"
                      name="description"
                      value={formData.description}
                      placeholder={translation.seeker_situation_ph}
                      onChange={handlePostDataChange}
                      className="az-input-btn"
                      required
                    />
                </div>
              </div>


            <div className="flex space-x-3">

            {isUpdate && 
              <button
                onClick={()=>{
                  setCurrentStep("select_create_seeker");
                }}
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
              >
                {translation.back}
              </button> 
            }
             
              <button
                onClick={isUpdate ? UpdatePostData : SubmitPostData  }
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600"
              >
                {translation.next} 
              </button>

            </div>
            {postDataErrorMessage && <div className="az-error-message">{postDataErrorMessage}</div>}

            {isLoading && (
              <div className="flex justify-center align-middle loading-icon">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900 dark:border-stone-100" />
              </div>)
            }


          </>
        ): currentState === "create_bank_details" ?  (
          <>
            <h2 className="mb-6 text-2xl dark:text-white">{seekerType} {translation.bank_details.heading2}</h2>

            <div className="pt-2 pb-5 space-y-4">
              {/* Bank Name */}
              {showBankDetailFields && (
                <div className="flex flex-col space-y-2">
                  <label htmlFor="bank_name" className="block font-semibold dark:text-white">
                  {translation.bank_details.bank_name}
                  </label>
                  <input
                    type="text"
                    id="bank_name"
                    name="bank_name"
                    placeholder={translation.bank_details.bank_ph}
                    value={bankFormData.bank_name}
                    required
                    onChange={handleBankDataChange}
                    className="az-input-btn"
                  />
                </div>
              )}

              {/* Account Holder */}
              {showBankDetailFields && (
                <div className="flex flex-col space-y-2">
                  <label htmlFor="account_holder" className="block font-semibold dark:text-white">
                  {translation.bank_details.account_holder_name}
                  </label>
                  <input
                    type="text"
                    id="account_holder"
                    required
                    name="account_holder"
                    placeholder={translation.bank_details.account_holder_name_ph}
                    value={bankFormData.account_holder}
                    onChange={handleBankDataChange}
                    className="az-input-btn"
                  />
                </div>
              )}

              {/* Account Number */}
              {showBankDetailFields && (
                <div className="flex flex-col space-y-2">
                  <label htmlFor="account_number" className="block font-semibold dark:text-white">
                  {translation.bank_details.account_number}
                  </label>
                  <input
                    type="tel"
                    id="account_number"
                    name="account_number"
                    onKeyDown={(e) => {
                      if (!/[0-9]/.test(e.key) && 
                          !["Backspace", "Delete", "Tab", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    step="1"
                    maxLength={15}
                    placeholder={translation.bank_details.account_number_ph}
                    required
                    value={bankFormData.account_number}
                    onChange={handleBankDataChange}
                    className="az-input-btn"
                  />
                </div>
              )}

              <hr />

              {/* No Bank Account Radio Button */}
              <div className="flex flex-col space-y-2">
                <label htmlFor="no_bank_account" className="block font-semibold dark:text-white">
                  <input
                    type="checkbox"
                    id="no_bank_account"
                    name="no_bank_account"
                    onChange={(e) => {setShowBankDetailFields(!e.target.checked)}}
                    className="mr-2 leading-tight"
                  />
                  <span className="text-sm">{translation.bank_details.no_bank_account}</span>
                </label>
              </div>

              {!showBankDetailFields && (
                <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
                  <p> 
                      {translation.seeker_dont_have_account}
                  </p>
                </div>

              )} 


            </div>
            
            {/* <CustomButton 
              label='Previous'
              className="mb-2 bg-black hover:bg-gray-800"
              onClick={() => setCurrentStep("select_create_seeker")}
            /> */}


          <div className="flex space-x-3">
            
          {isUpdate && 
            <button
                onClick={()=>{
                  setCurrentStep("create_post_details");
                }}
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
              >
                {translation.back}
              </button> 
            }
            <button
              onClick={isUpdate ? UpdatePostBankData: SubmitPostBankData}
              className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
            >
              {translation.next}
            </button>

            

          
          </div>
          {postDataErrorMessage && <div className="az-error-message ">{postDataErrorMessage}</div>}

          {isLoading && (
            <div className="flex justify-center align-middle loading-icon">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900 dark:border-stone-100" />
            </div>)
          }

          </>
        ): currentState === "attach_video_proofs" ?  (
          
          <>
            {postType === "medical case" ? (
              <MedicalPostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />

            ): postType === "marriage case" ? (
              <MarriagePostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "madrasa case" ? (
              <MadrasaPostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "masjid case" ? (
              <MasjidPostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "orphan case" ? (
              <OrphanPostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "widow case" ? (
              <WidowPostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ):(
              <FamilyPostVideoProofs translation={translation} postVideos={postVideos} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            )}
          </>

        ): currentState === "attach_doc_proofs" ? (
          <>
            {postType === "medical case" ? (
              <MedicalPostDocProofs translation={translation} docData={docData} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />

            ): postType === "marriage case" ? (
              <MarriagePostDocProofs translation={translation} docData={docData} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />

            ): postType === "madrasa case" ? (
              <MadrasaPostDocProofs translation={translation} docData={docData}  setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "masjid case" ? (
              <MasjidPostDocProofs translation={translation} docData={docData}  setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "orphan case" ? (
              <OrphanPostDocProofs translation={translation} docData={docData} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): postType === "widow case" ? (
              <WidowPostDocProofs translation={translation} docData={docData}  setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            
            ): (
              <FamilyPostDocProofs translation={translation} docData={docData} setCurrentStep={setCurrentStep} postSlug={postSlug} isUpdate={isUpdate} />
            )}
          </>
        ): (
          <>
            <div className="space-y-2">

              <div className="group relative overflow-hidden rounded-xl bg-teal-50 p-6 shadow-lg transition-all hover:shadow-xl dark:bg-teal-900/30">
                <div className="absolute -right-6 -top-6 text-9xl text-teal-100 opacity-50 transition-opacity group-hover:opacity-70 dark:text-teal-800">
                  <i className="fas fa-user-edit"></i>
                </div>
                <div className="relative">
                  <div className="mb-4 flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-teal-600 text-white">
                      <i className="fas fa-user text-lg"></i>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 dark:text-white/90">
                      {translation.submit_message}
                    </h3>
                  </div>
                </div>
              </div>
              
              {isUpdate && 
                <button
                  onClick={()=>{
                    setCurrentStep("attach_doc_proofs");
                  }}
                  className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
                >
                  {translation.back}
                </button> 
              }

              <button
                  type="submit"
                  onClick={viewPost}
                  className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
                >
                  {translation.view_post}
              </button>

            </div>
          </>
        )
      }
    </>
  )

  return (
    <>
      <Modal 
        isOpen={isOpen}
        close={close}
        label={isUpdate ? `${translation.update_modal_name} ${postType || "Post"}`: `${translation.modal_name} ${postType || "Post"}` }
        content={content}
      />
    </>
  )
}

export default CreateUpdatePostModal;